module.exports = require('./helpers/bundle-url').getBundleURL('gnRNX') + "08support.cf30f9ca.png" + "?" + Date.now();